import { Component, Input, OnChanges, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { BusinessLogoService } from "../../services/business-logo.service";
import { LogoContrastDirective } from "./logo-contrast.directive";
@Component({
  selector: "app-business-logo",
  imports: [LogoContrastDirective],
  template:
    '@if (url && !failed) {<img appLogoContrast crossorigin="anonymous" [src]="url" [alt]="label" [class.centered]="centered" (error)="failed=true">}',
  styles: [
    ":host{display:contents}img{display:block;max-width:min(220px,100%);max-height:64px;width:auto;height:auto;object-fit:contain;background:#fff;border-radius:10px;padding:8px;margin-bottom:12px}.centered{margin-inline:auto}",
  ],
})
export class BusinessLogoComponent implements OnChanges, OnDestroy {
  @Input() tenantId: number | string | null = null;
  @Input() path: string | null | undefined;
  @Input() label = "Business logo";
  @Input() centered = false;
  url: string | null = null;
  failed = false;
  private pending?: Subscription;
  constructor(private logos: BusinessLogoService) {}
  ngOnChanges() {
    this.pending?.unsubscribe();
    this.failed = false;
    this.url = this.logos.imageUrl(this.path);
    if (
      this.path ||
      !this.tenantId ||
      !/^[1-9][0-9]*$/.test(String(this.tenantId))
    )
      return;
    this.pending = this.logos.publicLogo(this.tenantId).subscribe({
      next: (logo) => {
        this.url = this.logos.imageUrl(logo?.path);
      },
      error: () => {
        this.url = null;
      },
    });
  }
  ngOnDestroy() {
    this.pending?.unsubscribe();
  }
}
